import Vue from 'vue'
import * as Sentry from '@sentry/vue'

// vue-router 3 rejects the promise returned by `push` on every guard redirect or
// interrupted navigation. These are expected outcomes of our own auth guards, not faults.
const routerNavigationNoise = [/^Navigation cancelled from /, /^Redirected when going from /, /^Avoided redundant navigation to current location/]

const environmentNoise = [
  /^ResizeObserver loop/,
  // Microsoft Outlook SafeLinks scanner injects this into pages it prefetches.
  /Object Not Found Matching Id/,
  // Android and iOS in-app browsers tear down their JS bridge before the page unloads.
  /Java object is gone/,
  /window\.webkit\.messageHandlers/,
  /Failed to register a ServiceWorker/,
  /sw\.js.*load failed/i,
  // HubSpot's collectedforms script logs through an incompatible console shim.
  /Level "ERROR" is not supported/,
  // Session expiry: the response interceptor already logs the user out and notifies them.
  /^Request failed with status code 401$/
]

// @sentry-internal/replay instrumenting cross-origin iframes it cannot reach.
const replayInstrumentationNoise = [/Failed to read a named property 'Element' from 'Window'/]

export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT

  if (dsn && environment) {
    Sentry.init({
      Vue,
      dsn,
      environment,

      ignoreErrors: [...routerNavigationNoise, ...environmentNoise, ...replayInstrumentationNoise],

      denyUrls: [/^chrome-extension:\/\//, /^moz-extension:\/\//, /^safari-web-extension:\/\//, /my\.productfruits\.com/],

      // Replay configuration
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,

      integrations: [
        Sentry.replayIntegration({
          maskAllText: false,
          maskAllInputs: true
        })
      ]
    })
  }
}
